import { Alert, Button } from 'antd';
import React from "react";
import { Link, useOutletContext, useRouteLoaderData } from 'react-router-dom';
import { generateRouteUrl } from '../../../library/constants';
import style from './artwork-received.module.scss';

const ArtWorkReceived = () => {
    const { orderDetails } = useRouteLoaderData('OrderManagerDetailsPage')
    const { getClientArtworks } = useOutletContext()

    return (
        <div className={style.container}>
            <h3>Task for you</h3>
            <Alert message="The customer has shared the artwork." type="info"
                action={
                    <div style={{ display: 'flex', gap: '8px' }}>
                        <Button className={style.greenButton} onClick={getClientArtworks}>Upload / Manage Artwork</Button>
                        <Link to={generateRouteUrl('CustomerArtworkToVendor', {
                            itemId: orderDetails.id,
                        })}>
                            <Button className={style.greenButton}>Send Artwork to Vendor</Button>
                        </Link>
                    </div>
                }
            />
        </div>
    )
}
export default ArtWorkReceived;